import React from 'react';
import { ImageWithPlaceholder } from '../ImageWithPlaceholder';
import { global } from '../../../utils';

export default function Cardescuela({data}) {
  const { imagen, titulo, fecha, municipio, escuela, cursos, estudiantes } = data;

  function formatDate(date) {
    const [yy,mm,dd] = date.split('-');
    return `${dd}/${mm}/${yy.slice(2)}`;
  }

  return (
    <div className='card-container'>
      <div className='card'>
        <div className="card__head">
          <ImageWithPlaceholder 
            src={`${global.managerURL}/archivos/eventos-rico/${imagen}`}
            alt={titulo}
          />
        </div>
        <div className="card__body">
          <h5>{titulo}</h5>
          <ul className='data'>
            <li className='fec'><i></i> <span><strong>{formatDate(fecha)}</strong></span></li>
            <li className='ciu'><i></i> <span><strong>Lugar: {municipio}</strong></span></li>
            <li className='esc'><i></i> <span><strong>Escuela: {escuela}</strong></span></li>
            <li className='cur'><i></i> <span><strong>Cursos: {cursos}</strong></span></li>
            <li className='est'><i></i> <span><strong>Estudiantes: {estudiantes}</strong></span></li>
          </ul>
        </div>
      </div>
    </div>
  );
}